module.exports = __webpack_public_path__ + "public/images/icons/hat.402140fff3e4e4dfc5277c50ee553a0a.png";